<template>
  <div>
    <v-chip color="primary" label text-color="white">
      <v-icon left small>mdi-alert-circle-outline</v-icon>
      Alunos em atenção
    </v-chip>

    <v-expansion-panels class="mt-2" flat>
      <v-expansion-panel>
        <v-expansion-panel-header color="primary lighten-5">
          <div class="d-flex align-center">
            <v-icon left color="primary">mdi-account-alert-outline</v-icon>
            <span class="primary--text text--darken-1 font-weight-medium">
              Ver alunos com menor média
            </span>
            <v-chip v-if="emAtencao.length" class="ml-2" x-small color="primary" text-color="white">
              {{ emAtencao.length }}
            </v-chip>
          </div>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <v-alert v-if="emAtencao.length === 0" dense text type="info" class="mt-3 mb-0">
            Nenhum aluno em atenção nesta turma.
          </v-alert>

          <v-card v-for="(item, i) in emAtencao" :key="i" light outlined class="mb-3 mt-3">
            <div class="d-flex flex-no-wrap justify-content">
              <div style="border-right: 1px solid #ccc" class="py-5 px-4 d-flex align-center">
                <v-icon large color="primary">mdi-alert-circle-outline</v-icon>
              </div>

              <div class="py-5 ml-2">
                <div>
                  <h3 class="primary--text text--darken-1 mb-3">
                    {{ item.aluno }}
                  </h3>
                </div>
                <v-divider></v-divider>
                <div class="mt-3">
                  <span>Média: {{ item.media }}</span> <br />
                  <span>Notas: {{ item.soma_notas }}</span> <br />
                  <span>Faltas: {{ item.qtdFaltas }}</span>
                </div>
              </div>
            </div>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  name: "EAlunosEmAtencao",
  props: {
    alunos: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    // Lista completa vem ordenada por média DESC (mesma origem dos "Melhores alunos").
    // "Em atenção" = alunos com uma das 3 MENORES médias distintas, excluindo os 3
    // melhores e apenas quem está abaixo da média do 3º melhor (evita rotular turma
    // homogênea/empatada no topo). Empate na média inclui todos -> pode passar de 3.
    emAtencao() {
      const melhores = this.alunos.slice(0, 3);
      if (melhores.length === 0) return [];

      const limiar = parseFloat(melhores[melhores.length - 1].media);
      const pool = this.alunos.slice(3);

      const candidatos = pool.filter((a) => parseFloat(a.media) < limiar);
      if (candidatos.length === 0) return [];

      const menoresDistintas = [...new Set(candidatos.map((a) => parseFloat(a.media)))]
        .sort((x, y) => x - y)
        .slice(0, 3);

      return candidatos
        .filter((a) => menoresDistintas.includes(parseFloat(a.media)))
        .sort((a, b) => parseFloat(a.media) - parseFloat(b.media));
    },
  },
};
</script>
